export default "__VITE_ASSET__ab075ec3__"